/**
 * MetalVision Kiosko - Configuration
 * Configuración centralizada con fallbacks
 */

// Detectar modo de desarrollo
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Detectar si estamos en red local (no localhost)
const isNetworkAccess = !isDev && (
  window.location.hostname.startsWith('192.168.') ||
  window.location.hostname.startsWith('10.0.') ||
  window.location.hostname.startsWith('172.')
);

// CONFIGURACIÓN: Autenticación SIEMPRE activada
// Solo se desactiva si explícitamente se pone enableMock=true
const ENABLE_AUTH = true;

// API URL: Usar config runtime, variable de entorno, o detectar automáticamente
let apiUrl = window.APP_CONFIG?.API_URL || import.meta.env?.VITE_API_URL || 'http://localhost:3000';
if (!window.APP_CONFIG?.API_URL && !import.meta.env?.VITE_API_URL && isNetworkAccess) {
  // Si accedemos desde red local sin config, usar la misma IP que el frontend
  apiUrl = `http://${window.location.hostname}:3000`;
}

// URL del backoffice (para el tipo de pantalla 'panel'): runtime config, env, o localhost:33100 en dev.
let backofficeUrl = window.APP_CONFIG?.BACKOFFICE_URL || import.meta.env?.VITE_BACKOFFICE_URL || '';
if (!backofficeUrl) {
  backofficeUrl = isDev ? 'http://localhost:33100' : `${window.location.protocol}//${window.location.hostname}`;
}

// Configuración por defecto para desarrollo con autenticación
export const CONFIG = {
  // API URL - detectada automáticamente
  apiUrl: apiUrl,

  // Backoffice (destino del panel informativo)
  backofficeUrl,
  
  // Autenticación de dispositivos - SIEMPRE activada
  enableDeviceAuth: ENABLE_AUTH,
  
  // Datos mock - false para usar API real
  enableMock: false,
  
  // Renovación de sesión
  sessionRenewalInterval: 15 * 60 * 1000, // 15 minutos
  
  // Logging
  logLevel: 'debug',
  
  // Modo desarrollo (para Service Worker)
  isDev: isDev
};

// Log de configuración
console.log('🔧 Configuración del Kiosko:', {
  hostname: window.location.hostname,
  isDev,
  isNetworkAccess,
  apiUrl: CONFIG.apiUrl,
  enableDeviceAuth: CONFIG.enableDeviceAuth,
  enableMock: CONFIG.enableMock,
  env: import.meta.env
});

// DEBUG: Descomentar para mostrar configuración en pantalla
// if (CONFIG.enableDeviceAuth) {
//   setTimeout(() => {
//     const debugDiv = document.createElement('div');
//     debugDiv.style.cssText = `
//       position: fixed;
//       bottom: 0;
//       left: 0;
//       right: 0;
//       background: rgba(0,0,0,0.8);
//       color: white;
//       padding: 5px;
//       font-size: 10px;
//       z-index: 99999;
//       font-family: monospace;
//     `;
//     debugDiv.innerHTML = `Auth=${CONFIG.enableDeviceAuth} | API=${CONFIG.apiUrl}`;
//     document.body.appendChild(debugDiv);
//   }, 100);
// }

// Validación
if (CONFIG.enableDeviceAuth && !CONFIG.apiUrl) {
  console.error('❌ Error: enableDeviceAuth está activado pero no hay apiUrl configurada');
}

if (CONFIG.enableDeviceAuth && CONFIG.enableMock) {
  console.warn('⚠️  Advertencia: enableDeviceAuth y enableMock están ambos activados. Esto puede causar conflictos.');
}
